/* -----------------UI--------------- */
import { Appbar } from "react-native-paper";

import StudySessionProgressBar from "../StudySessionProgressBar";
/* -----------------Child components--------------- */
import StudySessionAppBarLeft from "./StudySessionAppBarLeft";
import { StudySessionAppBarRight } from "./StudySessionAppBarRight";

import { isAndroid } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import useClerkUser from "@hooks/useClerkUser";
import { useDevice } from "@hooks/useDevice";
/* -----------------Globals--------------- */
import { Box } from "@memorang/ui";
import { sessionMaxWidth } from "../../constants";
import useSessionStore from "../../hooks/useSessionStore";

type Props = {
	numericId: number;
	examName?: string;
	timeRemaining?: string;
	handleClickRightCta: () => void;
	handleClickMenuItem: (type: "pause" | "help") => void;
	isTimerExpired?: boolean;
	showPause?: boolean;
	isAnswered?: boolean;
};
const StudySessionAppBar = ({
	numericId,
	examName,
	timeRemaining,
	handleClickRightCta,
	handleClickMenuItem,
	isTimerExpired,
	showPause,
	isAnswered,
}: Props) => {
	const { isMobile } = useDevice();
	const { username } = useClerkUser();
	const theme = useAppTheme();

	const isSummativeTest = useSessionStore((state) => state.isSummativeTest);
	const inReviewMode = useSessionStore((state) => state.inReviewMode);
	const isProethicaTest = useSessionStore(
		(state) => state.proethicaTestKind != null,
	);

	if (isMobile || !isSummativeTest) {
		return (
			<Appbar.Header
				mode={"small"}
				style={{
					justifyContent: "center",
					paddingTop: isAndroid ? 8 : 0,
					backgroundColor: isSummativeTest ? theme.colors.info.dark : undefined,
					height: 80,
				}}
			>
				<Box
					position="relative"
					width={"100%"}
					maxWidth={sessionMaxWidth.formative}
				>
					<Box flex={1}>
						<StudySessionProgressBar
							showClose
							showMenuIcon={isSummativeTest}
							handleAction={handleClickRightCta}
							handleClickMenuItem={handleClickMenuItem}
							isAnswered={isAnswered}
							fullWidth
						/>
					</Box>
				</Box>
			</Appbar.Header>
		);
	}

	const icon = isSummativeTest
		? inReviewMode
			? "check-circle-outline"
			: "pause-circle-outline"
		: "stop-circle-outline";
	const cta = isSummativeTest
		? inReviewMode
			? "End Review"
			: "Pause Session"
		: "End Session";

	return (
		<Appbar.Header
			mode="medium"
			style={{
				backgroundColor: isSummativeTest ? theme.colors.info.dark : undefined,
			}}
		>
			<Box
				justifyContent="space-between"
				flexDirection="row"
				width={"100%"}
				padding={16}
				alignItems="center"
			>
				{isSummativeTest ? (
					<Box flex={1}>
						<StudySessionAppBarLeft
							userName={username!}
							numericId={numericId}
							title={examName!}
						/>
					</Box>
				) : (
					<Box width={150} />
				)}
				<Box flex={1} maxWidth={800}>
					<StudySessionProgressBar />
				</Box>
				<Box flex={1} justifyContent="flex-end" flexDirection="row">
					<StudySessionAppBarRight
						cta={cta}
						icon={icon}
						handleAction={handleClickRightCta}
						timeRemaining={timeRemaining}
						showPause={showPause}
						isTimerExpired={isTimerExpired}
						isSummativeTest={isSummativeTest}
						isProethicaTest={isProethicaTest}
						isReview={inReviewMode}
					/>
				</Box>
			</Box>
		</Appbar.Header>
	);
};

export default StudySessionAppBar;
